import cloneDeep from 'lodash/cloneDeep';

const DEFAULT_STATE = {
    refreshing: false,
    success: true,
    loaded: false,
    error: null,
    user: null,
    userLoggedIn: false,
    userCardType: '',
    currentMarket: null,
    lang: 'en'
};

export default cloneDeep(DEFAULT_STATE);